import { Box, Container, Typography } from "@mui/material";
import { Button } from "@axismaxlife/unified-ui-components-library";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { PageTitle } from "../../commanComponents/PageTitle";
import { AppToast } from "../../commanComponents/AppToast";
import { PortfolioPolicyCard } from "./PortfolioPolicyCard";
import { useFinacialPortfolioService } from "../../api/apiEndpoints/FinancialPortfolio";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";
import { String } from "../../constants/Strings";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import {
  formatToIndianCurrency,
  formatToIndianShortCurrency,
} from "../../logic/CurrencyFormatter";
import { colors } from "../../style/color/colors";
import { fonts } from "../../style/fonts/fonts";

const COPY = String.CurrentPortfolio;

const formatInceptionDate = (dateStr) => {
  if (!dateStr) return "-";
  if (typeof dateStr === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  }
  return dateStr;
};

const formatPolicyTerm = (term) => {
  if (term === null || term === undefined || term === "") return "-";
  const num = parseFloat(term);
  return Number.isFinite(num) ? `${num}` : `${term}`;
};

const CurrentPortfolio = () => {
  const [portfolioData, setPortfolioData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { userId } = authTokens;

  const { fetchFinancialPortfolioDetails } = useFinacialPortfolioService();

  useEffect(() => {
    const fetchPortfolioData = async () => {
      try {
        const response = await fetchFinancialPortfolioDetails({ userId });

        if (response.httpCode === 200) {
          setPortfolioData(response.response?.portfolios || []);
        } else {
          throw new Error(COPY.failedToFetchData);
        }
      } catch (error) {
        setErrorMessage(error.message || COPY.failedToFetchData);
        setSnackbarOpen(true);
      }
    };

    fetchPortfolioData();
  }, []);

  const onHandleClick = () => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioContinue,
      verifyData.customerId,
    );
    navigate(String.navigations.financialquestion);
  };

  return (
    <Container>
      <PageTitle />
      <Typography
        sx={{
          mt: "16px",
          fontSize: "13px",
          fontFamily: fonts.notoSans,
          fontWeight: 400,
          color: colors.NeutralDark700,
          mb: "12px",
        }}
      >
        {COPY.overview}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "32px",
        }}
      >
        {portfolioData.map((policy, index) => (
          <PortfolioPolicyCard
            key={policy.policyNumber || index}
            labels={COPY.labels}
            planName={policy.planName || COPY.planName}
            policyNumber={policy.policyNumber || COPY.placeholderPolicyNumber}
            insuredName={`${policy.ownerClientName ?? ""}`}
            sumAssured={formatToIndianShortCurrency(policy.sumAssured)}
            premiumAmount={`${formatToIndianShortCurrency(
              policy.modelPremium,
            )}${COPY.perMonthSuffix}`}
            policyTerm={`${formatPolicyTerm(policy.policyTerm)} ${COPY.yearsSuffix}`}
            inceptionDate={formatInceptionDate(policy.issueDate)}
            totalPremiumPaid={formatToIndianCurrency(
              Number(policy.premiumReceivedTillDate) || 0,
            )}
          />
        ))}
      </Box>

      <Box sx={{ mt: "32px", mb: "24px" }}>
        <Button
          buttonType="primary"
          size="default"
          width="100%"
          onClick={onHandleClick}
        >
          {String.CurrentPortfolio.buttonText}
        </Button>
      </Box>

      <AppToast
        open={snackbarOpen}
        message={errorMessage}
        severity={String.ErrorSeverity}
        handleClose={() => setSnackbarOpen(false)}
      />
    </Container>
  );
};

export default CurrentPortfolio;
